import { isProcessableAttachmentUrl } from "@/store/note-attachments/url-utils";

/**
 * Mirrors `_is_external_https_image_url` in the note-derived-fields client:
 * an external image the service will internalize is an `https://` URL with a host
 * and no embedded basic-auth credentials, that is not already a
 * backend-downloadable (GCS / proxy) URL.
 *
 * The FE optimistic-PENDING write must target exactly this set so the
 * optimistic row's `resolve_note_attachment_uuid` id converges with the row the
 * service creates on save — anything looser orphans the row, anything tighter
 * drops the shimmer.
 */
export const isExternalHttpsImageUrl = (url: string): boolean => {
  if (isProcessableAttachmentUrl(url)) return false;

  // WHATWG `URL` collapses an empty authority (`https:///x`) and promotes the
  // next path segment to the host, whereas Python `urlparse` leaves `netloc`
  // empty. Require an explicit non-empty authority so the two agree.
  if (!/^https:\/\/[^/]/i.test(url)) return false;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }

  return (
    parsed.protocol === "https:" &&
    parsed.host.length > 0 &&
    parsed.username === "" &&
    parsed.password === ""
  );
};
